import LoginUiComponent from '../../components/loginUiComponent/loginUiComponent'
import OTPVerification from '../otpVerification/OTPVerification'
import { getLob, sendForgotPasswordOtpAddress, setAuthContext, verifyOtpFromServer } from '../../services/authenticationService';
import { maskEmail, padFunction } from '../otpVerification/otpVerificationUtils';
import { useLocation, useNavigate } from 'react-router-dom';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { eventEnum, logEvent } from '../../services/eventsService/eventService';
import { getAuthServiceState, getChannelDivision, sendOtp } from '../../services/salescodeAuthService';
import { useEffect, useState } from 'react';
import { ChannelkartNetworkGet } from '../../services/networkService';





function TwoFactorAuth(props: any) {
  const { userCredsInfo, twoFactorContactType, isEndToEnd, userName, password, loginContext, senderId} = props;
  const {  contactAddressType, contactAddress } = userCredsInfo;
  let {token, user, lob}= userCredsInfo;
  const [isAuthServiceEnabled,setIsAuthServiceEnabled]=useState<boolean>();

  const [otpLength, setOtpLength] = useState(6);

    useEffect(() => {
        (async () => {
            try {
                const response = await ChannelkartNetworkGet('/metadata/clientconfig?name=authentication_configuration');
                if (response?.status === 200 && response?.data?.features && response.data.features.length > 0 && response.data.features[0].domainValues) {
                    const configData = (response.data.features[0].domainValues as any[]).find((ele) => {
                        return ele.name === "otpLength";
                    });

                    if (configData?.value) {
                        setOtpLength(parseInt(configData?.value.toString()));
                    }
                }
            } catch (e) {}
        })();
    }, []);

  const navigate = useNavigate();
  useEffect(() => {
    const checkAuthService = async () => {
      const response = await getAuthServiceState(); 
      setIsAuthServiceEnabled(response.isAuthService); 
    };
    checkAuthService();
  }, []);
  const onFailure = (message: string) => {
    openPopup("Error", message);
  }

   const onSuccess = async (message: string, response?: any) => {
    try {
      const updatedUser = await setChannelDivisionForUser(user, token);
      setAuthContext(updatedUser, token);
      localStorage.setItem("lob", lob);

      sessionStorage.setItem("runPrepareCatalogue", 'true');
      sessionStorage.removeItem("TEMP_OTP_TOKKEN");
      sessionStorage.removeItem("TEMP_OTP_VERIFY_TOKKEN");
      logEvent(eventEnum.login, { feature_name: "login" });
      
      return navigate("/dashboard");
    } catch (error) {
      console.error("Error in onSuccess:", error);
      openPopup("Error", "An error occurred during login");
    }
  }

  // Common function to handle channel division logic
  const setChannelDivisionForUser = async (userObj: any, tokenValue: string) => {
    try {
      const isChannelDivision = await getChannelDivision(userObj?.designation, tokenValue);
      userObj["channelDivision"] = isChannelDivision;
      return userObj;
    } catch (error) {
      console.error("Error setting channel division:", error);
      return userObj;
    }
  };

  const resendOtp = async () => {
    try {
      if(isAuthServiceEnabled){
        const response = await sendOtp(userName,password,lob,isEndToEnd,"send-otp")
        if ('response' in response && response?.response?.status === "SUCCESS") {
          openPopup("Success", "OTP sent again");
        }
      }
      else{
      const response = await sendForgotPasswordOtpAddress(
        twoFactorContactType ? user["loginId"] : contactAddress ,
        contactAddressType,
        twoFactorContactType
      );
      if (response?.response?.statusCode === 200) {
        openPopup("Success", "OTP sent again");
      }
    }} catch (error: any) {
      openPopup("Error", error.message ?? "RESEND OTP ERROR");
      console.error(error);
    }
  }

  const verifyOTP = async (otp: string) => {
    if (otp && otp.length === otpLength) {
      try {
        let response ;
        if(isAuthServiceEnabled){
        response  =  await sendOtp(userName,otp,lob,isEndToEnd,"verify-otp", loginContext);
        if ('data' in response) { 
          if (response.status === 200) {
          let isChannelDivision = await getChannelDivision(response?.data?.user?.designation, response?.data?.token);
          response.data.user["channelDivision"] = isChannelDivision;
          token = response.data.token;
          user= response.data.user;
          lob =getLob();
            return { result: true, message: 'Success', response };
          }
        }
        else {
          return { result: false, message: "Please enter the correct OTP", response };
        }
      }
        else{
        response = await verifyOtpFromServer(
          otp,
          contactAddress,
          contactAddressType,
          undefined,
          senderId
        );
        if (response.data?.statusCode == 200 && response.data?.verified) {
          return { result: true, message: 'Success', response };
        } else {
          return { result: false, message: "Please enter the correct OTP", response };
        }
      }
       
      } catch (error) {
        return { result: false, message: "Please enter the correct OTP", response: null };
      }
    } 
      return { result: false, message: "Enter complete OTP", response: null };
  }


  return (
    <OTPVerification
    OtpVerficationHeader={
      <div className="otp-label">
        OTP sent to your registered{" "}
        {isAuthServiceEnabled
          ? "Login ID"
          : contactAddressType === "sms"
          ? "Phone Number"
          : "Email ID"}{" "}
        {isAuthServiceEnabled
          ? maskEmail(userName)
          : contactAddressType === "sms"
          ? padFunction(contactAddress)
          : maskEmail(userName)}
      </div>
    }
    otpLength={otpLength}
    onFailure={onFailure}
    onSuccess={onSuccess}
    resendOtp={resendOtp}
    verifyOTP={verifyOTP}
  />
  )
}

export default TwoFactorAuth
